import React, { useState } from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ReactComponent as Copy } from "../static/Icons/copy.svg";
import DoneAllIcon from "@mui/icons-material/DoneAll";

export default function CopyComponent({
  text,
  displayText,
  isRotate,
  handleRotate,
}) {
  const [copying, setCopying] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const handleCopy = async () => {
    setCopying(true);
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Copy failed:", err);
    } finally {
      setTimeout(() => {
        setCopying(false);
      }, 1500);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "#515151",
        color: "#fff",
        p: {
          xs: 1.5, // Mobile: 12px
          sm: 2, // Tablet: 16px
          md: 2, // Desktop: 16px
        },
        borderRadius: 1,
        whiteSpace: "pre-wrap",
        fontFamily: "monospace",
        fontSize: {
          xs: "12px", // Mobile
          sm: "13px", // Tablet
          md: "14px", // Desktop
        },
        display: "flex",
        alignItems: "flex-start", // Changed from center to flex-start for better text alignment
        position: "relative",
        minHeight: {
          xs: "40px",
          sm: "48px",
          md: "auto",
        },
        maxWidth: "100%",
        overflow: "hidden",
      }}
    >
      <Typography
        sx={{
          flexGrow: 1,
          pr: {
            xs: 6, // More space on mobile for button
            sm: 7,
            md: 6,
          },
          wordBreak: "break-word",
          overflowWrap: "break-word",
          lineHeight: {
            xs: 1.4,
            sm: 1.5,
            md: 1.6,
          },
        }}
      >
        {displayText || text}
      </Typography>

      <Box
        sx={{
          position: "absolute",
          right: {
            xs: "2px",
            sm: "5px",
            md: "5px",
          },
          top: {
            xs: "2px",
            sm: "5px",
            md: "5px",
          },
          display: "flex",
          flexDirection: {
            xs: "column", // Stack vertically on mobile if both buttons present
            sm: "row", // Side by side on tablet+
          },
          gap: {
            xs: 0.5,
            sm: 1,
          },
        }}
      >
        {/* Uncomment and adjust if you need the rotate button */}
        {/* {isRotate && (
          <IconButton
            sx={{ 
              color: "#fff", 
              fontSize: {
                xs: "20px",
                sm: "22px",
                md: "25px",
              },
              p: {
                xs: 0.5,
                sm: 1,
                md: 1,
              },
            }}
            onClick={handleRotate}
          >
            <Rotate />
          </IconButton>
        )} */}

        <IconButton
          sx={{
            color: "#fff",
            p: {
              xs: 0.5, // Smaller padding on mobile
              sm: 1,
              md: 1,
            },
            minWidth: {
              xs: "32px",
              sm: "40px",
              md: "auto",
            },
            minHeight: {
              xs: "32px",
              sm: "40px",
              md: "auto",
            },
          }}
          onClick={handleCopy}
        >
          {copying ? (
            <Tooltip
              title="Copied"
              arrow
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: { offset: [0, 0] },
                  },
                ],
              }}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#000",
                    color: "#fff",
                    fontSize: {
                      xs: "10px",
                      sm: "11px",
                      md: "12px",
                    },
                    borderRadius: 1,
                    px: {
                      xs: 1,
                      sm: 1.5,
                      md: 1.5,
                    },
                    py: 0.5,
                  },
                },
                arrow: { sx: { color: "#000" } },
              }}
            >
              <DoneAllIcon
                sx={{
                  fontSize: {
                    xs: "18px",
                    sm: "20px",
                    md: "24px",
                  },
                }}
              />
            </Tooltip>
          ) : (
            <Copy
              style={{
                width: isMobile ? "18px" : isTablet ? "20px" : "24px",
                height: isMobile ? "18px" : isTablet ? "20px" : "24px",
              }}
            />
          )}
        </IconButton>
      </Box>
    </Box>
  );
}
